import React from "react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  label: string;
  note?: string;
  dark?: boolean;
};
export function SectionCta({
  label,
  note = "One-time payment of $27 · Immediate access · 7-Day Guarantee",
  dark = false
}: SectionCtaProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl" data-id="element-59" data-mp="3ncjibncsxzau">
      <CtaButton label={label} data-id="element-60" data-mp="3nayo5yuegidi" />
      <p className={`mt-3 text-center text-sm ${dark ? "text-white/70" : "text-muted"}`} data-id="element-61" data-mp="3necu1h29v9pp">{note}</p>
    </div>;
}